import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { TestimonialInterface } from '../../interfaces/testimonial.interface';

@Component({
  selector: 'app-testimonial-card',
  standalone: true,
  imports: [CommonModule, MatCardModule, TranslateModule],
  template: `
    <mat-card class="testimonial-card">
      <mat-card-content>
        <p class="testimonial-content">"{{testimonial.content | translate}}"</p>
        <div class="rating">
          <span class="star" *ngFor="let star of [1,2,3,4,5]">★</span>
        </div>
        <p class="company">- {{testimonial.company | translate}}</p>
      </mat-card-content>
    </mat-card>
  `,
  styles: [`
    .testimonial-card {
      padding: 2rem;
      margin: 1rem;
      width: 100%;
      box-sizing: border-box;
    }

    .testimonial-content {
      font-size: 1.1rem;
      line-height: 1.6;
      margin-bottom: 1.5rem;
      font-style: italic;
    }

    .rating {
      margin-bottom: 1rem;
    }

    .star {
      color: #ffd700;
      font-size: 1.2rem;
    }

    .company {
      font-weight: 500;
      color: #666;
    }
  `]
})
export class TestimonialCardComponent {
  @Input() testimonial!: TestimonialInterface;
}